import styled, { keyframes } from "styled-components";

const transitionAnimation = keyframes`
  0% {
    transform: translate(-5px, 5px);    
  }
  100% {
    transform: translate(10px, -10px);
  }
`;

export const MainContainer = styled.div`
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  justify-content: center;
  background-color: white;
  border-radius: 16px;
`;

export const TransitionText = styled.p`
    margin-top: 30px;
    line-height: 24px;
    white-space: pre-line;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
`

export const ImageContainer = styled.div`
    margin-top: 70px;
    width: 100%;
    position: relative;
    max-width: 375px;
    height: 250px;
`;

export const ImageLine = styled.div`
    position: absolute;
    top: 0px;
    left: 25px;
    animation-name: ${transitionAnimation};
    animation-duration: 2.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    z-index: 10;
    width: 80%;
`;

export const ImageBackground = styled.div`
    position: absolute;
    top: 10px;
    left: 20%;
    max-width: 65%;
`;